import type { GmRewardType } from '@/components/entities/gamification/GmAwardCard/utils/types';
import type { GmRewardAction } from '@/components/features/gamification/model/types/gm-statuses';
import type { RewardTypeValue } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

/** `title` is resolved from `id` via the `gamification.perks.titles.<id>` intl key. */
export type GmRewardCardConfig = Omit<GmRewardType, 'title'> & {
  action?: GmRewardAction;
  /** Backend reward type; its grouped reward decides the card's availability and required status. */
  type?: RewardTypeValue;
};

// TODO: mock data is used
export const gamificationMockRewards: GmRewardCardConfig[] = [
  { id: 'level-up-scratch-card', subTitle: 'up to 0.5 SC', imgKey: 'level-up-scratch-card', action: 'level-up-card', type: GamificationRewardType.LevelUp },
  { id: 'status-up-scratch-card', imgKey: 'status-up-scratch-card', subTitle: 'Up to 2 SC', action: 'status-up-card', type: GamificationRewardType.StatusUp },
  { id: 'loss-insurance', imgKey: 'loss-insurance', subTitle: 'up to 2.5%' },
  { id: 'referral', imgKey: 'referral', subTitle: 'up to 3,500 SC' },
  { id: 'birthday-bonus', imgKey: 'birthday-bonus', isClaim: true, statusName: 'bronze' },
  { id: 'free-spins', imgKey: 'free-spins', statusName: 'gold' },
  { id: 'winners-pool', imgKey: 'winners-pool' },
  { id: 'weekly-playback', imgKey: 'weekly-playback', isClaim: true },
  { id: 'monthly-playback', imgKey: 'monthly-playback', isClaim: true },
];
